import mapboxgl from 'mapbox-gl'

window.mapboxMapApp = {};
(function (mapApp, $) {

    let mapDiv = $("#map-container");
    if (!mapDiv.length) return;

    mapApp.mapInit = function () {
        mapDiv.data('mapLoaded', true);
        mapboxgl.accessToken = mapDiv.data("accesstoken");
        let latitude = mapDiv.data("latitude");
        let longitude = mapDiv.data("longitude");
        let zoom = mapDiv.data("zoom");

        const map = new mapboxgl.Map({
            container: 'map-container',
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [longitude, latitude],
            zoom: zoom,
            cooperativeGestures: true
        });

        map.addControl(new mapboxgl.NavigationControl());

        mapDiv.siblings("#map-markers").find(".marker").each(function () {
            let element = document.createElement('div');
            if ($(this).attr('id') != undefined) element.id = $(this).attr('id');
            element.className = $(this).attr('class');
            element.setAttribute('data-article', $(this).attr('data-article'));
            let marker = new mapboxgl.Marker(element).setLngLat([$(this).data("longitude"), $(this).data("latitude")])
            if ($(this).find(".popup-content").length) {
                let popup = new mapboxgl.Popup({ offset: 25, maxWidth: 'none', focusAfterOpen: false, closeButton: false }).setHTML($(this).find(".popup-content").html());
                marker.setPopup(popup);
            }
            marker.addTo(map);
            $(this).remove();
        });

        mapDiv.on("click", ".js-close-popup", function () {
            $('.mapboxgl-popup').remove();
        });
    };


    $(document).ready(function () {
        if ($('.map-listings.with__grid').length) {
            $('.map-listings').on('loadMap', () => {
                if (mapDiv.length && !mapDiv.data('mapLoaded')) {
                    mapApp.mapInit();
                }
            })
        }
        else {
            mapApp.mapInit();
        }
    });

})(mapboxMapApp, jQuery);
